import {
    LOADING_DATA_IMAGES,
    SET_DATA_IMAGES,
    SET_ERROR_IMAGES
} from '../types'

const initialState = {
    loadingimages: false,
    images: [],
    message: '',
    error: ''
}


export default function (state = initialState, action) {
    switch (action.type) {
        case LOADING_DATA_IMAGES:
            return {
                ...state,
                loadingimages: true
            }
        case SET_DATA_IMAGES:
            return {
                loadingimages: false,
                ...action.payload
            }
        case SET_ERROR_IMAGES:
            return {
                loadingimages: false,
                ...action.payload
            }
        default: return state
    }
}